import React from 'react'
import classNames from 'classnames'
import { MagentoProductPrices } from 'lib/types'
import { DASH } from 'lib/core/resources/constants'
import { Price } from 'lib/shared'

interface Props {
  extraPrice?: number
  quantity?: number
  price: MagentoProductPrices
}

export const ConfigurableRange = ({ extraPrice = 0, price, quantity = 1 }: Props) => {
  const { regularPrice, minimalPrice, maximalPrice } = price || {}
  const { amount: amountRegular } = regularPrice || {}
  const { amount: amountMinimal } = minimalPrice || {}
  const { amount: amountMaximal } = maximalPrice || {}
  const { value: valueRegular, currency } = amountRegular || {}
  const { value: valueMinimal } = amountMinimal || {}
  const { value: valueMaximal } = amountMaximal || {}
  const hasSpecialPrice = valueMaximal < valueRegular

  if (!valueRegular || !currency) {
    return null
  }

  return (
    <>
      {hasSpecialPrice ? (
        <>
          <span
            className='specialPrice'
          >
            <Price
              value={(valueMaximal + extraPrice) * quantity}
              currency={currency}
            />
          </span>
          <span
            className={classNames({
              regularPrice: true
            })}
          >
            {` ${DASH} `}
            <Price
              value={(valueRegular + extraPrice) * quantity}
              currency={currency}
            />
          </span>
        </>
      ) : (
        <span
          className={classNames({
            regularPrice: true
          })}
        >
          <Price
            value={(valueMinimal + extraPrice) * quantity}
            currency={currency}
          />
        </span>
      )}
    </>
  )
}
